import { DashboardLayout } from 'shared/dashboard/Layout'
import { useBreakpoint } from 'slab'

export function SuspenseLayout () {
  const { breakpointIsAtLeast } = useBreakpoint()

  return (
    <DashboardLayout>
      {breakpointIsAtLeast('md')
        ? <DashboardLayout.Sidebar />
        : <DashboardLayout.MobileNavBar />}
      <DashboardLayout.Main />
    </DashboardLayout>
  )
}
